import $ from 'jquery';
import { hasLocalStorage } from 'lib/local-storage-check';
import BROWSERSLIST_REXEXP from 'lib/supportedBrowsers';

/**
 * Check if the current browser is supported based on browserslist config
 * @returns {boolean} Whether the current browser is supported
 */
function isBrowserSupported() {
  try {
    return BROWSERSLIST_REXEXP.test(navigator.userAgent);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error checking browser compatibility:', error);
    return false;
  }
}

const warningStorageKey = 'browser-warning';
const currentEpoch = Date.now();
const dismissTimeoutDays = 30;
const oneDayMs = 24 * 3600 * 1000;

/**
 * Check if the browser warning should be shown based on dismissal history
 * @returns {boolean} Whether the warning should be shown
 */
function shouldShowWarning() {
  if (!hasLocalStorage()) {
    return true;
  }

  if (localStorage.getItem(warningStorageKey)) {
    const warningStorage = JSON.parse(
      String(localStorage.getItem(warningStorageKey)),
    );
    const dismissedEpoch = warningStorage.epoch;
    if (currentEpoch - dismissedEpoch >= oneDayMs * dismissTimeoutDays) {
      localStorage.removeItem(warningStorageKey);
      return true;
    }
    return false;
  }
  return true;
}

/**
 * Handle the dismissal of the browser warning
 */
function handleWarningDismissal() {
  $('#browser-warning').fadeOut();
  if (hasLocalStorage()) {
    localStorage.setItem(
      warningStorageKey,
      JSON.stringify({
        dismissed: true,
        epoch: currentEpoch,
      }),
    );
  }
}

/**
 * Initialize browser compatibility warning
 * Shows warning if browser is not supported and hasn't been dismissed
 */
export function renderWarningBanner() {
  if (shouldShowWarning() && !isBrowserSupported()) {
    $(document).ready(() => {
      $('#browser-warning').show();
      $('#browser-warning-close-button').click(handleWarningDismissal);
    });
  } else {
    $(document).ready(() => {
      $('#browser-warning').hide();
    });
  }
}
